import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { Network, Users, Bot, Share2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '../Avatar';
import { Badge } from '../Badge';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../Chart';
const actors = [{
  id: 1,
  name: 'Budi Santoso',
  handle: '@budis_pengamat',
  platform: 'X',
  influence: 92,
  status: 'ORGANIK',
  followers: '1.2M',
  sentiment: 'NEGATIF'
}, {
  id: 2,
  name: 'Info Daerah Update',
  handle: '@infodaerah_up',
  platform: 'IG',
  influence: 88,
  status: 'TERKOORDINASI',
  followers: '850K',
  sentiment: 'NEGATIF'
}, {
  id: 3,
  name: 'Relawan Maju',
  handle: '@relawan_maju',
  platform: 'FB',
  influence: 85,
  status: 'TERKOORDINASI',
  followers: '500K',
  sentiment: 'POSITIF'
}, {
  id: 4,
  name: 'Siti Aminah',
  handle: '@sitiaminah_news',
  platform: 'TikTok',
  influence: 78,
  status: 'ORGANIK',
  followers: '2.1M',
  sentiment: 'NETRAL'
}, {
  id: 5,
  name: 'Kritik Pedas',
  handle: '@kritik_pedas99',
  platform: 'X',
  influence: 75,
  status: 'TERKOORDINASI',
  followers: '120K',
  sentiment: 'NEGATIF'
}];
const botData = [{
  platform: 'X',
  count: 4500
}, {
  platform: 'TikTok',
  count: 3200
}, {
  platform: 'FB',
  count: 2100
}, {
  platform: 'IG',
  count: 1800
}, {
  platform: 'YT',
  count: 950
}, {
  platform: 'Threads',
  count: 400
}];
const chartConfig = {
  count: {
    label: 'Bot Accounts',
    color: 'hsl(var(--destructive))'
  }
};
export function ActorNetworkPanel() {
  return <Card className="bg-card border-border/50 h-full flex flex-col" data-id="element-94">
      <CardHeader className="pb-2 pt-4 px-4 border-b border-border/50" data-id="element-95">
        <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-2" data-id="element-96">
          <Network className="size-4" data-id="element-97" />
          Actor Network & Telemetry
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-1 flex flex-col" data-id="element-98">
        <div className="p-4 border-b border-border/50" data-id="element-99">
          <h4 className="font-mono text-[10px] text-muted-foreground mb-3" data-id="element-100">
            TOP AKTOR PENGGERAK NARASI
          </h4>
          <div className="flex flex-col gap-3" data-id="element-101">
            {actors.map(actor => <div key={actor.id} className="flex items-center gap-3" data-id="element-102">
                <Avatar className="size-8 border border-border/50" data-id="element-103">
                  <AvatarImage src={`https://i.pravatar.cc/150?u=${actor.id}`} data-id="element-104" />
                  <AvatarFallback className="text-[10px]" data-id="element-105">
                    {actor.name.substring(0, 2).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0" data-id="element-106">
                  <div className="flex items-center gap-2" data-id="element-107">
                    <span className="text-xs font-bold truncate" data-id="element-108">
                      {actor.name}
                    </span>
                    <span className="font-mono text-[9px] text-muted-foreground truncate" data-id="element-109">
                      {actor.handle}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mt-0.5" data-id="element-110">
                    <span className="font-mono text-[8px] bg-muted px-1 rounded" data-id="element-111">
                      {actor.platform}
                    </span>
                    <span className="font-mono text-[8px] text-muted-foreground" data-id="element-112">
                      {actor.followers} flw
                    </span>
                    <span className="font-mono text-[8px] text-muted-foreground" data-id="element-113">
                      • Infl: {actor.influence}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1" data-id="element-114">
                  <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${actor.status === 'TERKOORDINASI' ? 'bg-amber-500/10 text-amber-500' : 'bg-blue-500/10 text-blue-500'}`} data-id="element-115">
                    {actor.status}
                  </Badge>
                  <span className={`font-mono text-[8px] ${actor.sentiment === 'NEGATIF' ? 'text-red-500' : actor.sentiment === 'POSITIF' ? 'text-emerald-500' : 'text-muted-foreground'}`} data-id="element-116">
                    {actor.sentiment}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="p-4 flex-1 flex flex-col" data-id="element-117">
          <h4 className="font-mono text-[10px] text-muted-foreground mb-3" data-id="element-118">
            COORDINATED BEHAVIOR DETECTION
          </h4>
          <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-119">
            <div className="bg-muted/30 border border-border/50 rounded p-2 flex flex-col items-center justify-center text-center" data-id="element-120">
              <Bot className="size-4 text-red-500 mb-1" data-id="element-121" />
              <span className="font-heading text-lg font-bold text-foreground" data-id="element-122">
                12.9K
              </span>
              <span className="font-mono text-[8px] text-muted-foreground" data-id="element-123">
                BOT DETECTED
              </span>
            </div>
            <div className="bg-muted/30 border border-border/50 rounded p-2 flex flex-col items-center justify-center text-center" data-id="element-124">
              <Users className="size-4 text-amber-500 mb-1" data-id="element-125" />
              <span className="font-heading text-lg font-bold text-foreground" data-id="element-126">
                42
              </span>
              <span className="font-mono text-[8px] text-muted-foreground" data-id="element-127">
                BUZZER CLUSTERS
              </span>
            </div>
            <div className="bg-muted/30 border border-border/50 rounded p-2 flex flex-col items-center justify-center text-center" data-id="element-128">
              <Share2 className="size-4 text-orange-500 mb-1" data-id="element-129" />
              <span className="font-heading text-lg font-bold text-foreground" data-id="element-130">
                8
              </span>
              <span className="font-mono text-[8px] text-muted-foreground" data-id="element-131">
                CAMPAIGNS
              </span>
            </div>
          </div>

          <div className="flex-1 min-h-[80px]" data-id="element-132">
            <ChartContainer config={chartConfig} className="h-full w-full" data-id="element-133">
              <BarChart data={botData} margin={{
              top: 0,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-134">
                <XAxis dataKey="platform" stroke="hsl(var(--muted-foreground))" fontSize={9} tickLine={false} axisLine={false} data-id="element-135" />
                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={9} tickLine={false} axisLine={false} data-id="element-136" />
                <RechartsTooltip content={<ChartTooltipContent hideLabel data-id="element-138" />} cursor={{
                fill: 'hsl(var(--muted)/0.5)'
              }} data-id="element-137" />
                <Bar dataKey="count" fill="var(--color-count)" radius={[2, 2, 0, 0]} data-id="element-139" />
              </BarChart>
            </ChartContainer>
          </div>
        </div>
      </CardContent>
    </Card>;
}